export enum PUBLISHER_TYPE {
    WEBSITE = 'WEBSITE',
    YOUTUBE = 'YOUTUBE',
    YOUTUBE_CHANNEL = 'YOUTUBE_CHANNEL',
    ANDROID_APP = 'ANDROID_APP',
    IOS_APP = 'IOS_APP',
    SOCIAL = 'SOCIAL',
    UNKNOWN = 'UNKNOWN',
}
